import loadable from "@loadable/component"
import { Text } from "iq-blueberry"
import Img from "@mkt/ui/components/common/Img"
import Condition from "@mkt/ui/components/common/Condition"

import * as S from "./styles"
import assertAssetURL from "@mkt/utils/assertAssetUrl"

const OutlineMoney = loadable(() =>
  import("iq-blueberry/dist/reactIcons/OutlineMoney")
)
const OutlineAnnuity = loadable(() =>
  import("iq-blueberry/dist/reactIcons/OutlineAnnuity")
)
const OutlineCalendar = loadable(() =>
  import("iq-blueberry/dist/reactIcons/OutlineCalendar")
)

const CardDetails = ({ content }) => {
  const {
    image,
    title,
    minimum_income: income,
    annuity,
    delivery_time: delivery,
  } = content
  return (
    <div css={S.container}>
      <div css={S.image}>
        <figure css={S.figure}>
          <Img
            src={assertAssetURL(image?.filename)}
            loading="eager"
            alt={`Foto do cartão ${title}`}
            css={S.figure}
          />
        </figure>
      </div>
      <div css={S.data}>
        <Text
          as="h1"
          defaultColor="subtitle"
          variant="heading-four"
          variantDesk="heading-one"
          css={S.text}
        >
          {title}
        </Text>
        <div css={S.benefitsContainer}>
          <div css={S.benefit}>
            <div css={S.label}>
              <OutlineMoney />
              <Text
                as="span"
                defaultColor="common"
                variant="body-small"
                variantDesk="body-medium"
                weight="400"
              >
                Renda Mínima:
              </Text>
            </div>

            <Text
              as="span"
              defaultColor="subtitle"
              variant="body-medium"
              weight="600"
            >
              {income}
            </Text>
          </div>
          <div css={S.benefit}>
            <div css={S.label}>
              <OutlineAnnuity />
              <Text
                as="span"
                defaultColor="common"
                variant="body-small"
                variantDesk="body-medium"
                weight="400"
              >
                Anuidade:
              </Text>
            </div>

            <Text
              as="span"
              defaultColor="subtitle"
              variant="body-medium"
              weight="600"
            >
              {annuity}
            </Text>
          </div>
          <Condition condition={delivery}>
            <div css={S.benefit}>
              <div css={S.label}>
                <OutlineCalendar />
                <Text
                  as="span"
                  defaultColor="common"
                  variant="body-small"
                  variantDesk="body-medium"
                  weight="400"
                >
                  Prazo:
                </Text>
              </div>

              <Text
                as="span"
                defaultColor="subtitle"
                variant="body-medium"
                weight="600"
              >
                {delivery}
              </Text>
            </div>
          </Condition>
        </div>
      </div>
    </div>
  )
}
export default CardDetails
